<template>
  <div id="detalleSolicitudRepresentacion" :data-ready="printReady">
    <v-toolbar>
      <img src="@/assets/logo_javer.png" height="60" width="auto">
      <v-spacer></v-spacer>
      <v-toolbar-title>Detalle de solicitud de Gastos de Representación</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6>
            <v-container>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Tipo de gastos
              </div>
              <v-radio-group v-model="solicitud.tipo_gasto" :mandatory="false" disabled>
                <v-radio label="Gastos de representación" color="primary" value="representacion" />
                <v-radio label="Gastos de atención al personal" color="primary" value="atencion_personal" />
                <v-radio-group v-if="solicitud.tipo_gasto == 'atencion_personal'" v-model="solicitud.tipo_atencion"
                  :mandatory="false" class="ml-5 mt-neg" disabled>
                  <div slot="label"><strong>Tipo de atencion</strong></div>
                  <v-radio label="Comida de Trabajo" value="comidas_trabajo" />
                  <v-radio label="Reuniones de Integración" value="reuniones_integracion" />
                </v-radio-group>
              </v-radio-group>

              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Tipo de pago
              </div>
              <v-radio-group v-model="solicitud.tipo_pago" :mandatory="false" disabled>
                <v-radio label="Transferencia" color="primary" value="transferencia" />
                <v-radio label="Cheque" color="primary" value="cheque" />
              </v-radio-group>
            </v-container>
          </v-flex>
          <v-flex xs6>
            <v-container>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Responsable
              </div>
              <v-text-field v-model="solicitud.nombre" disabled label="Nombre" />
              <v-text-field v-model="solicitud.puesto" disabled label="Puesto" />
              <v-text-field v-model="solicitud.departamento" disabled label="Departamento" />
              <v-text-field v-model="solicitud.direccion" disabled label="Plaza" />
              <v-text-field v-model="solicitud.empresa" disabled label="Empresa" />
              <v-text-field v-model="solicitud.centro" disabled label="Centro de costos" />
              <v-text-field v-model="solicitud.asistentes" disabled label="No. Asistentes" />

              <h3 class="grey--text firmas-titulo">FIRMAS DE APROBACIÓN</h3><br />
              <v-list three-line class="firmas-list">
                <template v-for="(item, i) in firmas">
                  <v-list-tile class="pb-2 pt-2">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                      <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                        v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                </template>
              </v-list>
            </v-container>
            <v-container>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Detalle de pago
              </div>
              <v-text-field v-model="solicitud.importe" disabled label="Importe" prefix="$" suffix="MXN" />
              <v-text-field v-model="solicitud.importe_letra" disabled label="Importe con letra" />
              <v-textarea v-model="solicitud.observaciones" disabled label="Observaciones" rows="4" auto-grow />
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import services from '@/config/services';
import axios from 'axios';
import printReady from '@/utils/printReady';

export default {
  name: 'detalleSolicitudRepresentacion',
  mixins: [printReady],
  data: () => ({
    solicitud: {
      tipo_gasto: null,
      tipo_atencion: null,
      tipo_pago: null,
      nombre: '',
      puesto: '',
      departamento: '',
      direccion: '',
      empresa: '',
      centro: '',
      asistentes: '',
      importe: '',
      importe_letra: '',
      observaciones: '',
    },
    firmas: [],
    loading: false,
  }),
  mounted() {
    this.fetchSolicitud();
  },
  methods: {
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    async fetchSolicitud() {
      this.loading = true;
      try {
        let idsolicitud = this.$route.query.idsolicitud;
        var token = this.$route.query.token;
        this.$session.start();
        this.$session.set('jwt', token);
        const jwt = this.$session.get('jwt');
        const headers = { Authorization: 'Bearer ' + jwt };
        const url = services.routes.representacionSolicitudesDetalle.replace(
          ':id',
          idsolicitud
        );
        const { data } = await axios.get(url, { headers });

        this.solicitud.tipo_gasto = data.tipo_gasto;
        this.solicitud.tipo_atencion = data.subtipo_atencion;
        this.solicitud.tipo_pago = data.tipo_pago;
        this.solicitud.nombre = data.nombre_responsable;
        this.solicitud.puesto = data.puesto;
        this.solicitud.departamento = data.idcat_departamento
          ? `${data.idcat_departamento.idexterno || ''} - ${data.idcat_departamento.descripcion || ''}`
          : '';
        this.solicitud.direccion = data.idcat_direccion
          ? `${data.idcat_direccion.idexterno || ''} - ${data.idcat_direccion.descripcion || ''}`
          : '';
        this.solicitud.empresa = data.idcat_empresa
          ? `${data.idcat_empresa.idexterno || ''} - ${data.idcat_empresa.descripcion || ''}`
          : '';
        this.solicitud.centro = data.idcat_centro_costo
          ? `${data.idcat_centro_costo.idexterno || ''} - ${data.idcat_centro_costo.descripcion || ''}`
          : '';
        this.solicitud.asistentes = data.numero_asistentes;
        this.solicitud.importe = data.importe;
        this.solicitud.importe_letra = data.importe_letra;
        this.solicitud.observaciones = data.observaciones;

        this.firmas = data.firmas || [];
        this.markPrintReady();
      } catch (err) {
        console.error('Error al cargar detalle:', err);
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>
